import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function CloseSection() {
  return <section className="bg-[#111111] py-24 px-4 pb-32" data-id="element-1">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-4">
            Tienes dos caminos frente a ti:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-5">
            {/* Camino A - Negative */}
            <div className="bg-[#0a0a0a] border border-white/5 rounded-2xl p-8 opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-6">
              <h3 className="text-xl font-bold text-gray-400 mb-4" data-id="element-7">Camino A</h3>
              <p className="text-gray-500 leading-relaxed" data-id="element-8">
                Seguir haciendo lo mismo. Crear contenido infinito para que
                Zuckerberg se haga rico mientras tú te agotas y tus ventas
                siguen en cero.
              </p>
            </div>

            {/* Camino B - Positive */}
            <div className="bg-gradient-to-b from-indigo-900/20 to-[#0a0a0a] border border-indigo-500/40 rounded-2xl p-8 shadow-[0_0_30px_rgba(99,102,241,0.1)] transform md:-translate-y-4" data-id="element-9">
              <h3 className="text-2xl font-bold text-indigo-400 mb-4" data-id="element-10">
                Camino B
              </h3>
              <p className="text-white text-lg leading-relaxed" data-id="element-11">
                Invertir menos de lo que cuesta una cena afuera en un sistema
                probado que te dará la estructura para vivir de internet en los
                próximos 30 días.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-12">
          <CTAButton className="w-full md:w-auto md:max-w-3xl py-6 text-xl md:text-2xl shadow-[0_0_30px_rgba(99,102,241,0.4)]" onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-13">
            SÍ, QUIERO CONSTRUIR MI NEGOCIO DIGITAL — ACCESO INMEDIATO POR $6.36
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}